export  enum PersonalEnum{
    CASHDESK = "CASHDESK",
    KITCHEN = "KITCHEN",
    WAITER = "WAITER",
    POS = "POS",

}

